<script setup lang='ts'>
import { onMounted, onUnmounted, ref, shallowRef } from 'vue';
import {
    MICRO_NAME,
    MICRO_URL,
    UPDATE_BUTTON_VISIBLE_EVENT,
    UPDATE_HIGHLIGHT_ENABLED_EVENT,
} from './constants';
import { useChemicalEntry } from './composables/use-chemical-entry';
import { usePermission } from '@/composables/use-permission';
import { loadMicroApp, prefetchApps } from 'qiankun';

const { permissions } = usePermission();

window.qiankunSingleton = window.qiankunSingleton || {
    loadMicroApp,
    prefetchApps,
};

const chemicalContainerRef = ref<HTMLElement | null>(null);
const micro = shallowRef<any>(null);

const {
    getWujieProps,
    updateButtonVisible,
    updateHighlightEnabled,
} = useChemicalEntry();

onMounted(() => {
    if (!chemicalContainerRef.value) return;

    window.addEventListener(UPDATE_BUTTON_VISIBLE_EVENT as any, updateButtonVisible);
    window.addEventListener(UPDATE_HIGHLIGHT_ENABLED_EVENT as any, updateHighlightEnabled);

    micro.value = window.qiankunSingleton?.loadMicroApp({
        name: MICRO_NAME,
        entry: MICRO_URL,
        container: chemicalContainerRef.value,
        props: getWujieProps(),
    });
});

onUnmounted(() => {
    window.removeEventListener(UPDATE_BUTTON_VISIBLE_EVENT as any, updateButtonVisible);
    window.removeEventListener(UPDATE_HIGHLIGHT_ENABLED_EVENT as any, updateHighlightEnabled);
    micro.value && micro.value.unmount();
});
</script>

<template>
    <div v-if="permissions.chemical" class="chemical-entry">
        <main ref="chemicalContainerRef" />
    </div>
</template>
